import Image from './image';

export type { ImageProps } from './image';
export default Image;
